// Shared by the Add and Edit product pages: how the SEO tab's form fields map to the API.

export const SITE_CATALOG_URL = "https://aapharmasyn.com/catalog/";

export const ROBOTS_OPTIONS = [
  { value: "index,follow", label: "Index, follow (default: show in search results)" },
  { value: "noindex,follow", label: "No index, follow (hide this product from search results)" },
  { value: "index,nofollow", label: "Index, no follow" },
  { value: "noindex,nofollow", label: "No index, no follow" },
];

// Form field values for an existing product (used to fill the Edit page).
export const seoDefaultsFromProduct = (product) => ({
  seoSlug: product?.slug || "",
  seoTitle: product?.seo_title || "",
  metaDescription: product?.meta_description || "",
  metaKeywords: product?.meta_keywords || "",
  metaRobots: product?.meta_robots || "index,follow",
  canonicalUrl: product?.canonical_url || "",
  ogTitle: product?.og_title || "",
  ogDescription: product?.og_description || "",
  ogImage: product?.og_image || "",
  jsonLd: product?.json_ld || "",
  customJs: product?.custom_js || "",
  customJsPosition: product?.custom_js_position || "bottom",
});

// Adds the SEO values to the request. On a new product the JSON-LD is not sent:
// the server prepares it from the product details once the product is saved.
export const appendSeoFields = (formData, data, { isEdit }) => {
  formData.append("slug", (data?.seoSlug || "").trim());
  formData.append("seo_title", data?.seoTitle || "");
  formData.append("meta_description", data?.metaDescription || "");
  formData.append("meta_keywords", data?.metaKeywords || "");
  formData.append("meta_robots", data?.metaRobots || "index,follow");
  formData.append("canonical_url", data?.canonicalUrl || "");
  formData.append("og_title", data?.ogTitle || "");
  formData.append("og_description", data?.ogDescription || "");
  formData.append("og_image", data?.ogImage || "");
  formData.append("custom_js", data?.customJs || "");
  formData.append("custom_js_position", data?.customJsPosition || "bottom");
  if (isEdit) {
    formData.append("json_ld", data?.jsonLd || "");
  }
};

// Returns an error message, or "" when the SEO data is fine.
export const validateSeoData = (data, { isEdit }) => {
  if (isEdit && data?.jsonLd && data.jsonLd.trim()) {
    let raw = data.jsonLd.trim();
    const wrapped = raw.match(/^<script[^>]*>([\s\S]*)<\/script>$/i);
    if (wrapped) raw = wrapped[1];
    try {
      const parsed = JSON.parse(raw);
      if (parsed === null || typeof parsed !== "object") {
        return "The JSON-LD data must be a JSON object.";
      }
    } catch (e) {
      return `The JSON-LD data is not valid JSON: ${e.message}`;
    }
  }
  if (data?.canonicalUrl && !/^https?:\/\//i.test(data.canonicalUrl.trim())) {
    return "The canonical URL must start with http:// or https://";
  }
  return "";
};

// Asks the admin to confirm before a published product URL is changed.
export const confirmSlugChange = (data, originalSlug) => {
  const next = (data?.seoSlug || "").trim();
  if (!originalSlug || !next || next === originalSlug) return true;
  return window.confirm(
    `You are changing the product URL.\n\nFrom: ${SITE_CATALOG_URL}${originalSlug}\nTo: ${SITE_CATALOG_URL}${next}\n\n` +
      "Search engines already know the old URL. It will keep working and redirect to the new one, " +
      "but rankings can still be affected for a while.\n\nChange the URL?"
  );
};
